(function () {
    'use strict';
    function start() {
        var root = document.querySelector('[data-porownanie-zestawow]');
        if (!root) return;
        var button = root.querySelector('[data-az-wczytaj]');
        var field = root.querySelector('[data-az-zestawy]');
        var status = root.querySelector('[data-az-status]');
        if (!button || !field || !status) return;
        button.addEventListener('click', function () {
            var api = window.PewniakiZestawy;
            var game = root.getAttribute('data-gra') || '';
            var sets = api && typeof api.lista === 'function' ? api.lista(game) : [];
            if (!Array.isArray(sets) || sets.length === 0) {
                status.textContent = status.getAttribute('data-empty') || '';
                return;
            }
            field.value = sets.slice(0, 10).map(function (set, i) {
                var name = String(set.name || (i + 1)).replace(/[\r\n:]+/g, ' ').trim();
                return name + ': ' + (Array.isArray(set.numbers) ? set.numbers.join(' ') : '');
            }).join('\n');
            status.textContent = status.getAttribute('data-ok') || '';
            field.focus();
        });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
})();
